import { useMemo } from 'react';
import { button_theme } from 'framework/button/constants';

import { useThemeContext } from '../../theme/context/ThemeContext';
import { ButtonTheme, ButtonThemePartial, ButtonVariant } from '../types';

export const useButtonTheme = (
  variant: ButtonVariant = 'normal',
  theme: Partial<ButtonThemePartial> = button_theme
): ButtonTheme => {
  const {
    theme: {
      button: {
        general,
        [variant]: { background, border, color },
      },
    },
  } = useThemeContext();

  return useMemo(
    () => ({
      general: { ...general, ...theme.general },
      background: { ...background, ...theme.background },
      border: { ...border, ...theme.border },
      color: { ...color, ...theme.color },
    }),
    [general, theme.general, theme.background, theme.border, theme.color, background, border, color]
  );
};
